import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { PageHome } from './pages';
import { Header } from './components/navigationals';

function App() {
	
	return (
		<BrowserRouter>
      		<Header />
        	<PageHome/>
	    </BrowserRouter>
	);
}

export default App;
